import { ListResource, Transaction, Charge, Refund } from 'services/resources';

export enum Actions {
  GET_TRANSACTION_LIST_FAILURE = 'app/services/Transactions/GET_TRANSACTION_LIST_FAILURE',
  GET_TRANSACTION_LIST_SUCCESS = 'app/services/Transactions/GET_TRANSACTION_LIST_SUCCESS',
  GET_TRANSACTION_RETRIEVE_FAILURE = 'app/services/Transactions/GET_TRANSACTION_RETRIEVE_FAILURE',
  GET_TRANSACTION_RETRIEVE_SUCCESS = 'app/services/Transactions/GET_TRANSACTION_RETRIEVE_SUCCESS',
  GET_CHARGE_LIST_FAILURE = 'app/services/Transactions/GET_CHARGE_LIST_FAILURE',
  GET_CHARGE_LIST_SUCCESS = 'app/services/Transactions/GET_CHARGE_LIST_SUCCESS',
  GET_CHARGE_RETRIEVE_FAILURE = 'app/services/Transactions/GET_CHARGE_RETRIEVE_FAILURE',
  GET_CHARGE_RETRIEVE_SUCCESS = 'app/services/Transactions/GET_CHARGE_RETRIEVE_SUCCESS',
  GET_REFUND_LIST_FAILURE = 'app/services/Transactions/GET_REFUND_LIST_FAILURE',
  GET_REFUND_LIST_SUCCESS = 'app/services/Transactions/GET_REFUND_LIST_SUCCESS',
  GET_REFUND_RETRIEVE_FAILURE = 'app/services/Transactions/GET_REFUND_RETRIEVE_FAILURE',
  GET_REFUND_RETRIEVE_SUCCESS = 'app/services/Transactions/GET_REFUND_RETRIEVE_SUCCESS',
  ADD_REFUND_SUCCESS = 'app/services/Transactions/ADD_REFUND_SUCCESS',
  ADD_REFUND_FAILURE = 'app/services/Transactions/ADD_REFUND_FAILURE',
  VOID_TRANSACTION_SUCCESS = 'app/services/Transactions/VOID_TRANSACTION_SUCCESS',
  VOID_TRANSACTION_FAILURE = 'app/services/Transactions/VOID_TRANSACTION_FAILURE',
}

export const receivedTransactionListFailure = (errors) => ({
  type: Actions.GET_TRANSACTION_LIST_FAILURE,
  payload: { errors },
});

export const receivedTransactionListSuccess = (transactions: ListResource<Transaction>) => ({
  type: Actions.GET_TRANSACTION_LIST_SUCCESS,
  payload: { transactions },
});

export const receivedTransactionRetrieveFailure = (errors) => ({
  type: Actions.GET_TRANSACTION_RETRIEVE_FAILURE,
  payload: { errors },
});

export const receivedTransactionRetrieveSuccess = (transaction: Transaction) => ({
  type: Actions.GET_TRANSACTION_RETRIEVE_SUCCESS,
  payload: { transaction },
});

export const receivedChargeListFailure = (errors) => ({
  type: Actions.GET_CHARGE_LIST_FAILURE,
  payload: { errors },
});

export const receivedChargeListSuccess = (charges: ListResource<Charge>) => ({
  type: Actions.GET_CHARGE_LIST_SUCCESS,
  payload: { charges },
});

export const receivedChargeRetrieveFailure = (errors) => ({
  type: Actions.GET_CHARGE_RETRIEVE_FAILURE,
  payload: { errors },
});

export const receivedChargeRetrieveSuccess = (charge: Charge) => ({
  type: Actions.GET_CHARGE_RETRIEVE_SUCCESS,
  payload: { charge },
});

export const receivedRefundListFailure = (errors) => ({
  type: Actions.GET_REFUND_LIST_FAILURE,
  payload: { errors },
});

export const receivedRefundListSuccess = (refunds: ListResource<Refund>) => ({
  type: Actions.GET_REFUND_LIST_SUCCESS,
  payload: { refunds },
});

export const receivedRefundRetrieveFailure = (errors) => ({
  type: Actions.GET_REFUND_RETRIEVE_FAILURE,
  payload: { errors },
});

export const receivedRefundRetrieveSuccess = (refund: Refund) => ({
  type: Actions.GET_REFUND_RETRIEVE_SUCCESS,
  payload: { refund },
});

export const receivedCreateRefundSuccess = (refund: Refund) => ({
  type: Actions.ADD_REFUND_SUCCESS,
  payload: { refund },
});

export const receivedCreateRefundFailure = (errors) => ({
  type: Actions.ADD_REFUND_FAILURE,
  payload: { errors },
});

export const receivedVoidTransactionSuccess = (transaction: Transaction) => ({
  type: Actions.VOID_TRANSACTION_SUCCESS,
  payload: { transaction },
});

export const receivedVoidTransactionFailure = (errors) => ({
  type: Actions.VOID_TRANSACTION_FAILURE,
  payload: { errors },
});
